export default __webpack_public_path__ + "./images/ug.5a205617.png";